import {
  SET_BASE_REQUEST_PATH,
  SET_JHA_TOKEN,
} from '../helpers/constants/actionsConstants';

export const setBaseRequestPath = (baseUrl: string) => ({
  type: SET_BASE_REQUEST_PATH,
  payload: baseUrl,
});

export const setJhaToken = (jhaToken: string) => ({
  type: SET_JHA_TOKEN,
  payload: jhaToken,
});
